<script>
    import { onMount, tick } from "svelte";
    import { fade, fly } from "svelte/transition";
    import { cubicOut } from "svelte/easing";
    import { currentRoute } from "./state/router";
    import NavBar from "./components/NavBar.svelte";
    import HomePage from "./pages/HomePage.svelte";
    import VehiclesPage from "./pages/VehiclesPage.svelte";
    import VehicleDetailsPage from "./pages/VehicleDetailsPage.svelte";
    import FinancingPage from "./pages/FinancingPage.svelte";
    import ApplicationPage from "./pages/ApplicationPage.svelte";
    import AboutPage from "./pages/AboutPage.svelte";
    import TestimonialsPage from "./pages/TestimonialsPage.svelte";
    import ContactPage from "./pages/ContactPage.svelte";
    import LoginPage from "./pages/LoginPage.svelte";
    import MgmtPage from "./pages/MgmtPage.svelte";
    import MgmtSettingsPage from "./pages/MgmtSettingsPage.svelte";
    import SiteFooter from "./components/SiteFooter.svelte";

    const pageTransitions = {
        in: { y: 12, duration: 180, easing: cubicOut },
        out: { duration: 90 },
    };

    const routeDefinitions = {
        home: { component: HomePage },
        vehicles: { component: VehiclesPage },
        "vehicle-details": {
            component: VehicleDetailsPage,
            navRoute: "vehicles",
            getProps: (activeRoute) => ({
                vehicleId: activeRoute.params?.inventoryId,
            }),
        },
        financing: { component: FinancingPage },
        application: { component: ApplicationPage },
        about: { component: AboutPage },
        testimonials: { component: TestimonialsPage },
        contact: { component: ContactPage },
        login: { component: LoginPage },
        mgmt: {
            component: MgmtPage,
            getProps: (activeRoute) => ({
                section: activeRoute.params?.section || "inventory",
            }),
        },
        "mgmt-settings": {
            component: MgmtSettingsPage,
            navRoute: "mgmt",
        },
    };

    let route = $state({
        name: "home",
        path: "/",
        params: {},
        queryParams: {},
    });

    const routeDefinition = $derived(routeDefinitions[route.name]);
    const PageComponent = $derived(routeDefinition?.component);
    const pageProps = $derived(routeDefinition?.getProps?.(route) ?? {});
    const navRoute = $derived(routeDefinition?.navRoute ?? route.name);

    async function scrollToPageTop() {
        await tick();
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }

    onMount(() => {
        const unsubscribe = currentRoute.subscribe((value) => {
            const pathChanged = value.path !== route.path;
            route = value;

            if (pathChanged) {
                scrollToPageTop();
            }
        });

        return unsubscribe;
    });
</script>

<NavBar activeRoute={navRoute} />

<main>
    {#key route.path}
        <div
            class="page-shell"
            in:fly={pageTransitions.in}
            out:fade={pageTransitions.out}
        >
            {#if PageComponent}
                <PageComponent {...pageProps} />
            {:else}
                <section><h1>Page not found</h1></section>
            {/if}
        </div>
    {/key}
</main>

<SiteFooter />

<style>
    .page-shell {
        display: grid;
        gap: var(--space-4);
    }
</style>
